import React from "react";
import { Reveal } from "@/lib/motion";

export const WhoThisIsFor = () => {
  return (
    <section
      id="for-who"
      data-testid="forwho-section"
      className="relative py-28 md:py-40 max-w-[1400px] mx-auto px-6 md:px-12"
    >
      <div className="mb-12 md:mb-16">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.28em] text-white/40">The Fit</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-syne font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[0.98]">
            Built <span className="font-cormorant italic font-light text-white/60">For You</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <p className="font-syne text-2xl md:text-3xl lg:text-[2.4rem] leading-[1.3] tracking-tight font-medium text-white/90 max-w-4xl">
          HANCOCK works with people at every stage, from complete beginners
          taking their first steps, to experienced lifters who've hit a wall
          and need a smarter approach.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <p className="mt-8 md:mt-10 font-syne text-2xl md:text-3xl lg:text-[2.4rem] leading-[1.3] tracking-tight font-medium text-white/90 max-w-4xl">
          If you're tired of guessing, ready to follow a real system, and open
          to being coached, let's talk.
        </p>
      </Reveal>
    </section>
  );
};
